export const APP_SYSTEM_SUSPEND_EVENT = "app-system-suspend"
export const APP_SYSTEM_RESUME_EVENT = "app-system-resume"

type SleepEventHandlers = {
	onPause: () => void
	onResume: () => void
}

export function subscribeSystemSleepEvents(handlers: SleepEventHandlers) {
	if (typeof window === "undefined") {
		return () => {}
	}

	let isPaused = false

	const pause = () => {
		if (isPaused) {
			console.log("[SleepResume][Events] Pause skipped (already paused)")
			return
		}
		isPaused = true
		console.log("[SleepResume][Events] Pause signal dispatched to subscribers")
		handlers.onPause()
	}

	const resume = () => {
		if (!isPaused) {
			console.log("[SleepResume][Events] Resume skipped (not paused)")
			return
		}
		isPaused = false
		console.log("[SleepResume][Events] Resume signal dispatched to subscribers")
		handlers.onResume()
	}

	window.addEventListener(APP_SYSTEM_SUSPEND_EVENT, pause)
	window.addEventListener(APP_SYSTEM_RESUME_EVENT, resume)
	console.log("[SleepResume][Events] Subscribed to system sleep events")

	return () => {
		window.removeEventListener(APP_SYSTEM_SUSPEND_EVENT, pause)
		window.removeEventListener(APP_SYSTEM_RESUME_EVENT, resume)
		console.log("[SleepResume][Events] Unsubscribed from system sleep events")
	}
}
